import { currencyColumn, dateColumn, numberColumn, primaryRelationshipColumn, relationshipColumn, textColumn } from "@api/schema/columnHelpers";
import { objectDefinition } from "@api/schema/supportedObjects";
import RapidReinvestmentSection from "./RapidReinvestmentSection";
import { forwardRef } from "react";

const relationshipType = 'event';
const {pluralName, color, endpoint} = objectDefinition(relationshipType);
const columns = [
    textColumn({column: 'name', label: 'Name', required: true}),
    dateColumn({column: 'date', required: true}),
    numberColumn({column: 'attendance', label: 'Attendance', inputType: 'number', required: true}),
];

const EventsHeld = forwardRef(function EventsHeld(props, ref) {
    return (
        <RapidReinvestmentSection
            type={relationshipType}
            columns={columns}
            {...props}
            ref={ref}
        />
    )
});

export {EventsHeld};
